module.exports = __webpack_public_path__ + "img/setting_21.9c8f7cc7.svg";